import * as S from "./DashboardContent.style";
import IconCheck from "../../../../styles/assets/img/icon_checkbox_checked.png";

interface DashboardProps {
  title?: React.ReactElement | string;
  legend?: React.ReactElement;
  children?: React.ReactElement;
}

export const DashboardContent = ({
  title,
  legend,

  children,
}: DashboardProps) => {
  return (
    <S.DashboardContentBox>
      <S.DashboardTitBox>
        <div style={{ display: "flex", flexDirection: "row", gap: "21px" }}>
          {title}
        </div>
        {legend}
      </S.DashboardTitBox>

      {children}
    </S.DashboardContentBox>
  );
};
